import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable, of } from "rxjs";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomDialogService } from '../../custom-dialog.service';

@Component({
  selector: 'app-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss']
})
export class CustomDialogComponent implements OnInit {

  actionType: string;
  message: string;
  downloadStatus  = 0;
  showOk: boolean;
  showCancel: boolean;
  okTitle: string;
  bulkError: any = [];
  bulkLinkShow  = false;
  cancelTitle = 'Cancel';
  successTitle = 'OK';

  private actionSubject = new Subject();
  action$ = this.actionSubject.asObservable();
  constructor(public activeModal: NgbActiveModal,
              public customDialogService: CustomDialogService) { }

  ngOnInit() {
    this.configButtons();
    this.getBulkErrors();
    
  }

  getBulkErrors(){
    this.bulkError = this.customDialogService.getErrorArray();
    if(this.bulkError.length > 0){
      this.bulkLinkShow = true;
    }
    else{
      this.bulkLinkShow = false;
      this.customDialogService.setErrorArray([]);
    }
  }
  
  onCancel() {
    this.customDialogService.setErrorArray([]);
    this.actionSubject.next('dismiss');
    this.activeModal.dismiss();
  }

  onOk() {
    this.actionSubject.next(this.actionType);
    this.activeModal.dismiss();
  }

  downloaErrorLog(){
    console.log('hit');
    this.dynamicDownloadTxt(this.bulkError);
  }

  configButtons() {
    if (this.actionType === 'dismiss') {
      this.showOk = false;
      this.showCancel = true;
      this.successTitle = 'DONE';
    } else if (this.actionType === 'yes') {
      this.showOk = true;
      this.showCancel = true;
      this.okTitle = 'Yes';
    } else if (this.actionType === 'add') {
      this.showOk = false;
      this.showCancel = true;
      this.okTitle = 'Create New';
    } else if (this.actionType === 'failedToSubmit') {
      this.showOk = false;
      this.showCancel = true;
      this.successTitle = 'OK';
      this.bulkLinkShow = false;      
    }
    else if (this.actionType === 'ratingScale') {
      this.showOk = false;
      this.showCancel = true;
      this.successTitle = 'DONE';
    }
    else if (this.actionType === 'email') {
      this.showOk = false;
      this.showCancel = true;
      this.okTitle = 'OK'
    }
  }


  //code for Error log file 
  fakeValidateUserData(errorArray) {
    let errors : any = [];
    let errorObj = ''
    for(let index = 0; index<errorArray.length; index++){
      errors.push(errorArray[index]);
    }
    return of(errors);
  }

  private setting = {
    element: {
      dynamicDownload: null as HTMLElement
    }
  }

  dynamicDownloadTxt(errosList) {
    this.fakeValidateUserData(errosList).subscribe((res) => {
      if(res){
        console.log('res ', res);
        let data = 'Errors list \n';
        for(let i = 0; i<res.length;i++){
          data = data + res[i]+'\n';
        }
        this.dyanmicDownloadByHtmlTag({
          fileName: 'Error Log',
          text: data
        });
      }
      
    });
  }

  private dyanmicDownloadByHtmlTag(arg: {
    fileName: string,
    text: string
  }) {
    if (!this.setting.element.dynamicDownload) {
      this.setting.element.dynamicDownload = document.createElement('a');
    }
    const element = this.setting.element.dynamicDownload;
    const fileType = arg.fileName.indexOf('.json') > -1 ? 'text/json' : 'text/plain';
    element.setAttribute('href', `data:${fileType};charset=utf-8,${encodeURIComponent(arg.text)}`);
    element.setAttribute('download', arg.fileName);

    var event = new MouseEvent("click");
    element.dispatchEvent(event);
  }


}
